module.exports = __webpack_public_path__ + "static/img/jianjieImg.db81c484.png";